export default __webpack_public_path__ + "media/images/flags/ct-837f0a7188183252d24e9de20c8c70bb.png";